









































































































































































































































import TheHeader from "@/common/components/organisms/TheHeader.vue";
import TheFooter from "@/common/components/organisms/TheFooter.vue";
import CommonHeading from "@/common/components/atoms/CommonHeading.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconComment from "@/common/components/icons/IconComment.vue";
import IconInvestedRounded from "@/common/components/icons/IconInvestedRounded.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import M01AccountAnchor from "@/general/components/pages/parts/MyPage//M01AccountAnchor.vue";
import ModalMain from "@/common/components/organisms/ModalMain.vue";
import TheBreadcrumb from "@/common/components/organisms/TheBreadcrumb.vue";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import modalState from "@/common/store/modules/modalState";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { getGrantCriteriaList, getUserProfile } from "@/general/store/api";
import { mapState } from "vuex";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import { UserInfo } from "@/general/store/models";
import AuthStorage from "@/general/utils/auth";
import AuthApi from "@/general/api/authApi";
@Component({
  components: {
    TheHeader,
    TheFooter,
    CommonHeading,
    ButtonMain,
    IconUserImage,
    IconBase,
    IconComment,
    IconInvestedRounded,
    PointNotation,
    M01AccountAnchor,
    ModalMain,
    TheBreadcrumb
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class MyPage extends Vue {
  @Prop({ type: String, default: "", required: false }) modal!: string;
  points: any = 0;
  closeModalState = modalState.closeModalState;
  changeModal: any = "";
  organizationId!: string;
  currentPage!: number;
  userInfo: UserInfo = {} as UserInfo;
  id!: any;
  unit = commons.unit;
  conditions = commons.conditions;
  modalName = this.modal;
  avatar = "";

  breadcrumb = [
    {
      text: "",
      url: CONST_DATA.SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "マイページ",
      url: CONST_DATA.SITE_MAP.DEFAULT,
      pageType: "lower"
    }
  ];

  $refs!: {
    theHeader: TheHeader;
  };

  get urlPointConfirmation() {
    return CONST_DATA.SITE_MAP.POINT_CONFIRMATION;
  }

  get registrationDate() {
    if (this.userInfo && this.userInfo.application_start_date) {
      return this.$dayjs
        .utc(this.userInfo.application_start_date)
        .locale("ja")
        .format("YYYY/MM/DD");
    }
    return null;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  @Watch("closeModalState")
  onCloseModalState() {
    modalState.changeModal("");
  }

  closeModal() {
    this.modalName = "";
  }
  get point() {
    return this.points;
  }
  get currentPointFontSize() {
    return this.isSp ? 28 : 32;
  }
  get conditionPointFontSize() {
    return this.isSp ? 14 : 24;
  }
  get profileIconSize() {
    const isSpScreenWidth = globals.isSpScreenWidth;
    return isSpScreenWidth ? 80 : 96;
  }

  get urlGrantCriteria() {
    return CONST_DATA.SITE_MAP.GRANT_CRITERIA;
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const organizationParam = commons.Orgspecific?.id;

    this.organizationId = organizationParam;
    this.id = 0;

    const userProfile = await getUserProfile("");
    this.points = userProfile.data.total_points;
    this.userInfo = auth.user;

    const grantCriteriaList = await getGrantCriteriaList(
      "",
      this.currentPage,
      4,
      ""
    );
    this.conditions = grantCriteriaList.results;
    await commons.getBreadcrumb(this.breadcrumb);

    if (this.modal) {
      this.changeModal(this.modal);
    }
    
    //#59042対応によりセッション情報からavatarを取得するように修正
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.avatar = ic_session.avatar;
    })
    .catch(() => {
      this.avatar = "";
    });
  }
}
